import styled from "@emotion/styled"
import type { PTextProps } from "@porsche-design-system/components-react"
import {
	leadingNormal,
	typescale2Xs,
	typescaleLg,
	typescaleMd,
	typescaleSm,
	typescaleXs,
} from "@porsche-design-system/components-react/emotion"
import { SkeletonComponent } from "./SkeletonComponent"

const mapSizeToTypeScale: Record<Extract<PTextProps["size"], "2xs" | "xs" | "sm" | "md" | "lg">, string> = {
	"2xs": typescale2Xs,
	lg: typescaleLg,
	md: typescaleMd,
	sm: typescaleSm,
	xs: typescaleXs,
}

export const SkeletonText = styled(SkeletonComponent)<{
	$width?: string
	size?: keyof typeof mapSizeToTypeScale
}>`
	${({ size }) => size && `font-size: ${mapSizeToTypeScale[size]};`}
	height: ${leadingNormal};
	max-width: 100%;
`
